import { render, staticRenderFns } from "./FormCaracterization.vue?vue&type=template&id=3c88717a"
import script from "./FormCaracterization.vue?vue&type=script&lang=js"
export * from "./FormCaracterization.vue?vue&type=script&lang=js"
import style0 from "./FormCaracterization.vue?vue&type=style&index=0&id=3c88717a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports